export default "__VITE_ASSET__BKwdF8g1__"